import { endpoints } from 'modules/endpoints'
import { octopusApiClient } from 'modules/utils/httpClient'

export default {
  updateOrders: () => octopusApiClient.get(endpoints.target2sku('update_orders')),
} as const
